module.exports = __webpack_public_path__ + "img/visa-5-logo-black-and-white.753fa24d.png";